import script from "./RecentTransactionsSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./RecentTransactionsSection.vue?vue&type=script&setup=true&lang=ts"

import "./RecentTransactionsSection.vue?vue&type=style&index=0&id=87bf21dc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-87bf21dc"]])

export default __exports__